import { string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Footer } from 'styled_components/Common/Footer';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const LargeInfoC = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 238px;
	height: 262px;
	position: relative;
	background: ${props => props.theme.componentBackground};
	color: ${props => props.theme.defaultFontColor};
	.buttons {
		position: absolute;
		bottom: 16px;
		width: 100%;
		display: flex;
		justify-content: space-around;
	}
	.header {
		img {
			width: 40px;
			height: 40px;
			margin-left: 16px;
			margin-right: 16px;
			filter: grayscale(100%);
		}
	}
	.main-display {
		width: 240px;
		height: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		position: relative;
		#notifications-button {
			position: absolute;
			bottom: 0;
		}
	}

	.large-info-footer {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
	}

	.divider {
		width: 100%;
		height: 2px;
		border-radius: 15px;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.boxShadow} inset;
	}

	.info-display {
		width: 272px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		.header {
			display: flex;
			height: 70px;
			align-items: center;
		}
		.main-info {
			height: 130px;
			display: flex;
			flex-direction: column;
			padding-left: 15px;
			padding-top: 5px;

			.field {
				display: flex;
				flex-direction: row;
				align-items: flex-start;
				min-height: 20px;
				.label {
					display: flex;
					flex-direction: row;
					align-items: flex-start;
					width: 70px;
					min-height: 20px;
					margin-bottom: 5px;
				}
				.value {
					min-height: 20px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					width: 135px;
				}
				&.ADDRESS {
					.value {
						white-space: wrap;
					}
				}
			}
		}
	}
	.section {
		width: 100%;
		height: 95px;

		.title-wrapper {
			height: 30px;
			display: flex;
			align-items: flex-end;

			.title {
				margin-bottom: 5px;
				margin-left: 16px;
			}
		}

		.ScrollbarsCustom-Track {
			right: 10px !important;
			top: 0px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.account} !important;
			width: 6px !important;
		}
		.ScrollbarsCustom-TrackY:before {
			border-left: none;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 6px !important;
		}
		.activities-header {
			display: flex;

			margin-bottom: 6.5px;
			margin-top: 5px;
			margin-left: 16px;

			.header-option {
				margin-right: 16px;

				&.type {
					width: 56px;
					background-color: transparent;
					box-shadow: none;
				}
				&.city {
					width: 40px;
				}
				&.date {
					width: 80px;
				}
			}
		}
		.activities-wrapper {
			display: flex;
			flex-direction: column;

			.activities-body {
				display: flex;
				flex-direction: column;

				.activity {
					display: flex;
					margin-left: 16px;
					.value {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						margin-right: 16px;
						margin-bottom: 6px;
						background-color: transparent;
						box-shadow: none;
						&.type {
							width: 56px;
						}
						&.city {
							width: 40px;
						}
						&.date {
							width: 80px;
						}
					}
				}
			}
		}
	}

	.top {
		display: flex;
		align-items: center;
		padding-top: 8px;
		padding-bottom: 8px;
	}
	.bottom {
		position: absolute;
		bottom: 16px;
		display: flex;
		flex-direction: column;
		#user-profile {
			position: absolute;
			right: 8px;
			bottom: 8px;
		}
	}

	.detail-one,
	.detail-two,
	.detail-three {
		color: ${props => props.theme.Cool_Gray_Dark_2};
		margin-left: 16px;
	}
	.detail-one {
		margin-left: 8px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 352px;
		height: 384px;

		.buttons {
			position: absolute;
			bottom: 24px;
			width: 100%;
			display: flex;
			justify-content: space-around;
		}
		.main-display {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			#action-button {
				margin: 25px;
			}
		}

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}

		.info-display {
			width: 100%;
			height: 100%;

			.header {
				display: flex;
				height: 104px;
				align-items: center;
			}
			.main-info {
				height: 200px;
				display: flex;
				flex-direction: column;
				padding-left: 24px;

				.field {
					display: flex;
					flex-direction: row;
					margin-bottom: 10px;
					.label {
						width: 110px;
						margin-bottom: 2px;
					}
					.value {
						width: 190px;
					}
				}
			}
			.main-footer {
				display: flex;
				height: 50px;
				justify-content: center;
				align-items: center;
			}
		}
		.section {
			width: 100%;
			height: 172px;

			.title-wrapper {
				height: 38px;

				.title {
					margin-bottom: 5px;
					margin-left: 24px;
				}
			}

			.main-footer {
				display: flex;
				height: 50px;
				justify-content: center;
				align-items: center;
			}
			.ScrollbarsCustom-Track {
				right: 15px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 8px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 8px !important;
			}
			.activities-header {
				display: flex;
				margin-bottom: 6.5px;
				.header-option {
					margin-left: 10px;

					&.type {
						width: 56px;
						background-color: transparent;
						box-shadow: none;
					}
					&.city {
						width: 40px;
					}
					&.date {
						width: 80px;
					}
				}
			}
			.activities-wrapper {
				display: flex;
				flex-direction: column;

				.activities-body {
					display: flex;
					flex-direction: column;
					margin-left: 10px;
					.activity {
						display: flex;

						.value {
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							margin-right: 16px;
							margin-bottom: 6px;
							background-color: transparent;
							box-shadow: none;
							&.type {
								width: 56px;
							}
							&.city {
								width: 60px;
							}
							&.date {
								width: 80px;
							}
						}
					}
				}
			}
		}
		.header {
			img {
				width: 72px;
				height: 72px;
				margin-left: 16px;
				margin-right: 16px;
				filter: grayscale(100%);
			}
		}
		.top {
			display: flex;
			align-items: center;
			padding-top: 8px;
			padding-bottom: 8px;
		}
		.bottom {
			position: absolute;
			bottom: 16px;
			display: flex;
			flex-direction: column;
			#user-profile {
				position: absolute;
				right: 8px;
				bottom: 8px;
			}
		}

		.detail-one,
		.detail-two,
		.detail-three {
			color: ${props => props.theme.Cool_Gray_Dark_2};
			margin-left: 16px;
		}
		.detail-one {
			margin-left: 8px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 432px;
		height: 608px !important;

		.divider {
			width: 100%;
			height: 2px;
			border-radius: 15px;
			background-color: ${props => props.theme.Cool_Gray_Light_3};
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.boxShadow} inset;
		}
		.main-display {
			width: 100%;
			height: 600px;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
		}

		.info-display {
			width: 100%;
			height: 608px;

			.header {
				display: flex;
				height: 150px;
				align-items: center;
			}
			.main-info {
				width: 100%;
				height: 325px;
				display: flex;
				flex-direction: column;
				padding-left: 40px;

				.field {
					display: flex;
					flex-direction: row;
					height: 32px;
					margin-bottom: 20px;
					.label {
						width: 140px;
						margin-bottom: 1px;
					}
					.value {
						width: 220px;
					}
				}
			}
		}
		.section {
			width: 100%;
			height: 300px;

			.title-wrapper {
				height: 68px;

				.title {
					margin-bottom: 5px;
					margin-left: 40px;
				}
			}

			.main-footer {
				display: flex;
				height: 150px;
				justify-content: center;
				align-items: center;
			}
			.ScrollbarsCustom-Track {
				right: 20px !important;
				top: 0px !important;
			}

			.ScrollbarsCustom-ThumbY {
				width: 10px !important;
			}
			.ScrollbarsCustom-TrackY {
				width: 10px !important;
			}
			.activities-header {
				display: flex;
				margin-bottom: 6.5px;
				.header-option {
					margin-left: 25px;

					&.type {
						width: 106px;
						background-color: transparent;
						box-shadow: none;
					}
					&.city {
						width: 90px;
					}
					&.date {
						width: 130px;
					}
				}
			}
			.activities-wrapper {
				display: flex;
				flex-direction: column;

				.activities-body {
					display: flex;
					flex-direction: column;
					margin-left: 25px;
					.activity {
						display: flex;
						margin-bottom: 10px;
						.value {
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							margin-right: 16px;
							margin-bottom: 6px;
							background-color: transparent;
							box-shadow: none;
							&.type {
								width: 106px;
							}
							&.city {
								width: 90px;
							}
							&.date {
								width: 130px;
							}
						}
					}
				}
			}
		}
		.header {
			img {
				width: 88px;
				height: 88px;
				margin-left: 16px;
				margin-right: 16px;
				filter: grayscale(100%);
			}
		}
		.top {
			display: flex;
			align-items: center;
			padding-top: 8px;
			padding-bottom: 8px;
		}
		.bottom {
			position: absolute;
			bottom: 16px;
			display: flex;
			flex-direction: column;
			#user-profile {
				position: absolute;
				right: 8px;
				bottom: 8px;
			}
		}

		.detail-one,
		.detail-two,
		.detail-three {
			color: ${props => props.theme.Cool_Gray_Dark_2};
			margin-left: 16px;
		}
		.detail-one {
			margin-left: 8px;
		}
	}
`;

function renderDefaultContent(data) {
	const header = data?.header;
	const main = data?.main;
	const fields = main?.fields;

	return (
		<div className='info-display'>
			<div className='header'>
				{' '}
				<img className='image' src={header?.image} alt='header' data-cy={`item-image-`} />
				<div className='header-details-wrapper'>
					<div className='header-title heading70'>{header?.title}</div>
					<div className='header-details-1 body10'>{header?.details1}</div>
				</div>
			</div>
			<div className='divider'></div>
			<div className='main-info'>
				{fields &&
					fields.map(field => (
						<div className='main-fields'>
							<div className={`field ${field?.label}`}>
								<div className='label labels21'>{field?.label}</div>
								<div className='value body10'>{field?.value}</div>
							</div>
						</div>
					))}
			</div>
		</div>
	);
}

function renderActivities(data) {
	return (
		<div className='activities-wrapper'>
			<div className='activities-body'>
				{data.map(item => {
					return (
						<div className='activity'>
							<div className='value type body10'>{item?.type}</div>
							<div className='value city body10'>{item?.city}</div>
							<div className='value date body10'>{item?.displayDate}</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export const LargeInfoDisplay = ({ type, data, onClick, cypressId, customBody, id, image }) => {
	const footer = data?.footer;

	return (
		<LargeInfoC className={`large-info-card`} id={`large-info-card-${id}`}>
			{type === 'customBody' && customBody}
			{type === 'default' && renderDefaultContent(data)}
			{type === 'activities' && (
				<div className='info-display'>
					<div className='header'>
						{' '}
						<img className='image' src={image} alt='header' data-cy={`item-image-`} />
						<div className='header-details-wrapper'>
							<div className='header-title heading70'>Recent Activities</div>
							<div className='header-details-1 body10'></div>
						</div>
					</div>
					<div className='divider'></div>
					<div className='section'>
						<div className='activities-header'>
							<div className='header-option type'>
								<div className='header-title  labels21'>TYPE</div>
							</div>
							<div className='header-option city'>
								<div className='header-title labels21'>CITY</div>
							</div>
							<div className='header-option date'>
								<div className='header-title labels21'>LAST LOGIN</div>
							</div>
						</div>
						<ScrollView>{renderActivities(data)}</ScrollView>
					</div>
				</div>
			)}

			<div className='large-info-footer'>
				{type !== 'activities' ? (
					<Footer
						cypressId={cypressId}
						id={footer?.buttonID}
						buttonText1={footer?.buttonText}
						module='account'
						buttonFunction1={onClick}
						//buttonFunction2={() => {}}
					/>
				) : (
					<Footer
						cypressId={cypressId}
						id={'notifications-button'}
						buttonText1='View More'
						module='account'
						buttonFunction1={onClick}
					/>
				)}
			</div>
		</LargeInfoC>
	);
};
LargeInfoDisplay.propTypes = {
	type: string.isRequired,
};

LargeInfoDisplay.defaultProps = {};
